
export const SET_USER = 'SET_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const NOTIFICATION = 'NOTIFICATION';